var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.75C12 1.165 11.665 1.5 11.25 1.5H0.75C0.335 1.5 0 1.165 0 0.75C0 0.335 0.335 0 0.75 0H11.25C11.665 0 12 0.335 12 0.75ZM7.25 9H4.75C4.335 9 4 9.335 4 9.75C4 10.165 4.335 10.5 4.75 10.5H7.25C7.665 10.5 8 10.165 8 9.75C8 9.335 7.665 9 7.25 9ZM9.25 4.5H2.75C2.335 4.5 2 4.835 2 5.25C2 5.665 2.335 6 2.75 6H9.25C9.665 6 10 5.665 10 5.25C10 4.835 9.665 4.5 9.25 4.5Z",
    fill: "#586370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.5a82459dae6fd5ac8f0c05715c002af6.svg";
export { ForwardRef as ReactComponent };